var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-modal',{attrs:{"title":"订单支付","width":600,"dialog-style":{ top: '20px' },"maskClosable":false,"visible":_vm.visible,"footer":null},on:{"cancel":_vm.handleCancel}},[_c('p',{staticStyle:{"line-height":"1.3em","color":"red"}},[_vm._v("暂不支持在线支付")])])
}
var staticRenderFns = []

export { render, staticRenderFns }